import { render } from "./CANDIDATE_VAL_REVOKED.vue?vue&type=template&id=a9193046"
import script from "./CANDIDATE_VAL_REVOKED.vue?vue&type=script&lang=js"
export * from "./CANDIDATE_VAL_REVOKED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__